var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13255_135761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.5C3.81281 0.5 0 4.31281 0 9C0 13.6872 3.81281 17.5 8.5 17.5C13.1872 17.5 17 13.6865 17 9C17 4.31348 13.1872 0.5 8.5 0.5ZM8.5 16.1832C4.5397 16.1832 1.3168 12.961 1.3168 9C1.3168 5.03903 4.5397 1.8168 8.5 1.8168C12.4603 1.8168 15.6832 5.03903 15.6832 9C15.6832 12.961 12.461 16.1832 8.5 16.1832Z",
    fill: "#1D3557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.792 8.28226H9.15842V5.64865C9.15842 5.28521 8.86411 4.99023 8.5 4.99023C8.1359 4.99023 7.84158 5.28521 7.84158 5.64865V8.28226H5.20798C4.84387 8.28226 4.54956 8.57723 4.54956 8.94068C4.54956 9.30412 4.84387 9.59909 5.20798 9.59909H7.84158V12.2327C7.84158 12.5961 8.1359 12.8911 8.5 12.8911C8.86411 12.8911 9.15842 12.5961 9.15842 12.2327V9.59909H11.792C12.1561 9.59909 12.4504 9.30412 12.4504 8.94068C12.4504 8.57723 12.1561 8.28226 11.792 8.28226Z",
    fill: "#1D3557"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13255_135761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOrder);
export default __webpack_public_path__ + "static/media/addOrder.bc0f1c99e01dae2c81d6d70046eb819f.svg";
export { ForwardRef as ReactComponent };